export const BROWSE_MFE_URL_PREFIX = "/browse";
export const BREAK_POINT = 1040;
export const SEARCH_PATH_PREFIX = "/search?from=browse&browseTopic=";
export const CONTENT_PATH_PREFIX = "/content/contenttype/";
export const GATEWAY_URL =
  process.env.NODE_ENV === "development"
    ? "https://www.dh.eis-deliverydevqa.cloud"
    : "";
